const SUGGESTIONS_SELECTOR = '[data-component="search-suggestions"]';
const INPUT_SELECTOR = '[data-component="search-input"]';
const FILLED_CLASS = 'search__suggestions--filled';
const DESKTOP_CLASS = 'search__highlights--desktop';

export default function SearchHighlights(config = {}) {
  return {
    visible: false,
    loaded: false,
    largeScreenMinWidth: Number(config.largeScreenMinWidth ?? 1024),
    observer: null,

    init() {
      this.observer = new MutationObserver(() => this.onSuggestionsChanged());

      document.querySelectorAll(SUGGESTIONS_SELECTOR).forEach((element) => {
        this.observer.observe(element, { attributes: true, attributeFilter: ['class'] });
      });
    },

    destroy() {
      this.observer?.disconnect();
      this.observer = null;
    },

    onFocus(event) {
      if (!event.target.closest(INPUT_SELECTOR)) {
        return;
      }

      if (!this.isForCurrentScreen()) {
        return;
      }

      this.load();
      this.visible = !this.hasSuggestions();
    },

    onSuggestionsChanged() {
      if (!this.loaded) {
        return;
      }

      this.visible = !this.hasSuggestions();
    },

    hasSuggestions() {
      return [...document.querySelectorAll(SUGGESTIONS_SELECTOR)]
        .some((element) => element.classList.contains(FILLED_CLASS));
    },

    isForCurrentScreen() {
      const isLargeScreen = window.innerWidth >= this.largeScreenMinWidth;

      return this.$el.classList.contains(DESKTOP_CLASS) === isLargeScreen;
    },

    load() {
      if (this.loaded) {
        return;
      }

      this.loaded = true;
      this.$wire.load();
    }
  };
}
